// Modules
import React from 'react';
import PropTypes from 'prop-types';
// Styles
import * as styles from './PromoBlockItem.scss';

const PromoBlockItem = props => (
    <div
      className={styles.item}
    >
      {props.contentText}
    </div>
  );

PromoBlockItem.propTypes = {
  contentText: PropTypes.string
};

export default PromoBlockItem;
